import { z } from 'zod';

export const nullStr = () => z.string().nullable().default(null);
export const nullNum = () => z.number().nullable().default(null);
export const nullBool = () => z.boolean().nullable().default(null);
export const nullObj = <T extends z.ZodRawShape>(shape: T) =>
  z
    .object(shape)
    .loose()
    .nullable()
    .default(() => ({}) as any);
export const nullArr = <T extends z.ZodTypeAny>(item: T) =>
  z.array(item).nullable().default([]);
